import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Exception, ExceptionCreate, VehicleExcel } from '../../services/http/exceptions/exceptions.interface';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CustomInputFileComponent } from '../custom-input-file/custom-input-file.component';
import { AlertService } from '../../services/alert/alert.service';
import { ApplicantsService } from '../../services/http/applicants/applicants.service';
import { CountriesService } from '../../services/http/countries/countries.service';
import { ExceptionsService } from '../../services/http/exceptions/exceptions.service';
import { MunicipalitiesService } from '../../services/http/municipalities/municipalities.service';
import { VehiclesService } from '../../services/http/vehicles/vehicles.service';
import { WordpressService } from '../../services/http/wordpress/wordpress.service';
import { LoaderService } from '../../services/loader/loader.service';
import { ApplicantIndividualContact, ApplicantRequest } from '../../services/http/applicants/applicants.interface';
import { CodeName, RequestDate, TimestampCustom } from '../../services/http/common.http.interface';
import { Vehicle, VehicleRquest, VehicleType, VehicleTypeResponse } from '../../services/http/vehicles/vehicles.interface';
import { WpClientCode, WpPost, WpSectionCode } from '../../services/http/wordpress/wordpress.interface';
import { MunicipalityManagement } from '../../services/http/municipalities/municipalities.interface';
import { AttachmentUtil } from '../../services/utils/attachment.utils';
import { Attachment } from '../../services/http/attachments/attachments.interface';
import { AlertType } from '../../services/alert/alert.interface';
import { Observable, forkJoin } from 'rxjs';
import { Country } from '../../services/http/countries/countries.interface';

@Component({
  selector: 'app-exception',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, CustomInputFileComponent],
  templateUrl: './exception.component.html',
  styleUrl: './exception.component.scss'
})
export class ExceptionComponent {
  @Input() applicantId: string = '';
  @Input() exceptionId: string = '';
  @Input() plate: string = '';
  @Input() selectedVehicle: string | null = null
  @Input() autType: string | null = null
  @Input() disablleAll: boolean = false;
  @Input() hideInfo: boolean = false;
  @Output() goBackEvent = new EventEmitter<void>();

  newException: ExceptionCreate = {
    type: {
      code: ''
    },
    municipality: '',
    municipalities: [""],
    attachments: [],
    flags: {
      email: false,
      sms: false,
      personal: false,
      privacity: false,
      veracity: false,
      protection: false,
      vehicleDocumentation: false
    }
  };
  options: any[] = [];
  vehiclesTypes: VehicleType[] = [];
  authorizationsWp: WpPost[] = [];
  descriptionTop = '';
  descriptionFiles = '';
  haveMultipleCars: boolean = false;
  showRepresent: boolean = true;
  showCompany: boolean = true;
  municipalities: MunicipalityManagement[] = [];
  vehicleFound: boolean = false;
  vehicles: Vehicle[] = [];
  vehiclesToCreate: VehicleRquest[] = [];
  createdVehiclePlate: string | null = null;
  createdVehicleAlias: string | null = null;
  ownerDeclaration: boolean = false;
  applicant: ApplicantRequest | undefined;
  countries: Country[] = [];
  countryName: string | undefined;
  streetTypes: CodeName[] = [];
  today = new Date();
  filesToShow: boolean[] = [true, false, false, false, false, false, false, false, false, false];
  filesToAdd: any[] = [undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined];
  authTypeUrl: string = '';
  multiple = false;

  typeTratmedFrom: Date = new Date();
  typeTratmedTo: Date = new Date();
  typeMunicipalFrom: Date = new Date();
  typeMunicipalTo: Date = new Date();

  multipleFile: Attachment | undefined;
  vehiclesFromExcel: VehicleExcel[] = [];

  tipServCode: string = '';

  constructor(
    private vehiclesService: VehiclesService,
    private exceptionsService: ExceptionsService,
    private activeRoute: ActivatedRoute,
    private readonly municipalitiesService: MunicipalitiesService,
    private readonly loaderService: LoaderService,
    private readonly alertService: AlertService,
    private readonly applicantsService: ApplicantsService,
    private readonly wordpressService: WordpressService,
    private readonly countriesService: CountriesService
  ) { }

  get maxDate(): string {
    if (!this.typeMunicipalFrom) return ''; // Si no hay fecha inicial, no poner límite
    const fromDate = new Date(this.typeMunicipalFrom);
    fromDate.setDate(fromDate.getDate() + 3); // Añadir 3 días
    return fromDate.toISOString().split('T')[0]; // Formato 'yyyy-MM-dd'
  }

  ngAfterViewInit() {
    this.getMDMs();
    this.applicantsService.getApplicant(this.applicantId).subscribe((applicant: ApplicantRequest) => {
      this.applicant = applicant;
      if (applicant.represented) {
        this.getCountryName(applicant.represented.applicantContact.countryCode);
      } else if (applicant.individual) {
        this.getCountryName(applicant.individual.applicantContact.countryCode);
      } else if (applicant.company) {
        this.getCountryName(applicant.company.applicantContact.countryCode);
      } else {
        this.countryName = '';
      }
    });
    if (this.exceptionId && this.plate) {
      if (this.applicantId) {
        this.exceptionsService.getExceptionByApplicant(this.applicantId, this.exceptionId, this.plate).subscribe((exception) => {
          this.makeThings(exception);
        });
      } else {
        this.exceptionsService.getException(this.exceptionId, this.plate).subscribe((exception) => {
          this.makeThings(exception);
        });
      }
    }
  }

  makeThings(exception: Exception) {
    this.tipServCode = exception.type.options ? exception.type.options[0].code : '';
    this.newException = exception;
    this.selectedVehicle = exception.vehiclePlate;
    this.changeType();
    this.changeVehicle();
    this.filesToAdd = exception.attachments || [];
    this.filesToShow = new Array(exception.attachments.length).fill(true);
    if (this.newException.type_tratmed !== undefined) {
      this.typeTratmedFrom = new Date(this.newException.type_tratmed.from.timestamp);
      this.typeTratmedTo = new Date(this.newException.type_tratmed.to.timestamp);
    }
    if (this.newException.type_municipal !== undefined) {
      this.typeMunicipalFrom = new Date(this.newException.type_municipal.from.timestamp);
      this.typeMunicipalTo = new Date(this.newException.type_municipal.to.timestamp);
    }
  }

  getCountryName(code: number): void {
    this.countriesService.getCountries().subscribe((countries) => {
      this.countries = countries.countries;
      this.countryName = countries.countries.find((country) => country.code === code)?.name;
    });
  }

  getMDMs() {
    this.vehiclesService.getVehicleesByApplicant(this.applicantId).subscribe((vehicles) => {
      this.vehicles = vehicles.elements;
      this.authTypeUrl = this.autType || '';
      if (this.selectedVehicle == 'new') {
        this.vehiclesToCreate.push({
          vehicleAlias: '',
          vehiclePlate: ''
        } as VehicleRquest
        );
      } else if (this.selectedVehicle) {
        this.createdVehiclePlate = this.selectedVehicle;
        this.createdVehicleAlias = this.vehicles.find((vehicle) => vehicle.vehiclePlate === this.selectedVehicle)?.vehicleAlias || '';
        this.vehicleFound = this.vehicles.some((vehicle) => vehicle.vehiclePlate === this.selectedVehicle);
      }
      if (this.autType == 'multiple') {
        this.autType = 'VPMR';
        this.newException.type = {
          code: this.autType
        }
        this.multiple = true;
        this.haveMultipleCars = true;
        this.setTypes();
      } else if (this.autType) {
        this.newException.type = {
          code: this.autType
        }
        this.setTypes();
      }
    });
    this.vehiclesService.getVehicleTypes().subscribe((data: VehicleTypeResponse) => {
      // check if url contains FOREIGN
      if (!window.location.href.includes('FOREIGN')) {
        var aux = data.registrations.filter((type) => type.code !== 'FOREIGN');
      } else {
        var aux = data.registrations;
      }
      if (this.activeRoute.snapshot.paramMap.get('code') == 'multiple') {
        aux = aux.filter((type) => type.multiple);
      }
      this.vehiclesTypes = aux;
    });
    this.municipalitiesService.getMunicipalitiesManagement().subscribe((data) => {
      this.municipalities = data.municipalities;
    });

    this.wordpressService.getPosts({ section: WpSectionCode.autorizationType, client: WpClientCode.genCat }).subscribe((response) => {
      this.authorizationsWp = response || [];
      if (this.authTypeUrl) {
        const autType = this.authorizationsWp.find((post) => post.acf.aluvisa_id === this.authTypeUrl);
        if (autType) {
          this.descriptionTop = autType.acf.descripcion;
          this.descriptionFiles = autType.acf.ficheros;
        } else {
          this.descriptionTop = '';
          this.descriptionFiles = '';
        }
      }
    });

    this.exceptionsService.getSteetTypes().subscribe(
      data => {
        this.streetTypes = data.streets;
      }
    );
  }

  changeType() {
    if (this.newException.type) {
      this.options = this.vehiclesTypes.find((type) => type.code === this.newException.type?.code)?.options || [];
      if (this.options.length > 0) {
        this.newException.type.options = [
          {
            code: ''
          }
        ]
      } else {
        this.newException.type.options = undefined;
      }
      const codeType = this.vehiclesTypes.find((type) => type.code === this.newException.type?.code)?.code;
      if (codeType) {
        const autType = this.authorizationsWp.find((post) => post.acf.aluvisa_id === codeType);
        if (autType) {
          this.descriptionTop = autType.acf.descripcion;
          this.descriptionFiles = autType.acf.ficheros;
        } else {
          this.descriptionTop = '';
          this.descriptionFiles = '';
        }
      }
      this.haveMultipleCars = this.vehiclesTypes.find((type) => type.code === this.newException.type?.code)?.multiple || false;
    } else {
      this.options = [];
    }
    this.setTypes();
  }

  setTypes() {
    switch (this.newException.type.code) {
      case 'VPMR':
        this.showRepresent = false;
        this.showCompany = false;
        if (this.newException.type_vpmr === undefined) {
          this.clearTypes();
          this.newException.type_vpmr = {
            anotherPerson: false,
            applicant: {
              name: '',
              firstSurname: '',
              secondSurname: '',
              documentIdentification: '',
              documentType: '',
              dateOfBirth: {} as RequestDate,
            },
            collective: false
          };
        }
        break;
      case 'MALALT':
        this.showRepresent = false;
        this.showCompany = false;
        if (this.newException.type_malalt === undefined) {
          this.clearTypes();
          this.newException.type_malalt = {
            medicalCenter: '',
            selfResponsibility: false,
            TSI: '',
            vehicleOwner: {
              applicantIdentification: {
                name: '',
                firstSurname: '',
                secondSurname: '',
                documentIdentification: '',
                documentType: '',
                dateOfBirth: {} as RequestDate,
              },
              applicantContact: {} as ApplicantIndividualContact
            }
          }
        };
        break;
      case 'MUNICIPAL':
        this.showRepresent = true;
        this.showCompany = true;
        if (this.newException.type_municipal === undefined) {
          this.clearTypes();
          this.newException.type_municipal = {
            contact: {
              countryCode: 0,
              phoneNumber: '',
              province: '',
              municipality: '',
              streetName: '',
              streetNumber: '',
              floor: '',
              door: '',
              stairCase: '',
              block: '',
              postalCode: '',
              email: '',
              streetTypeCode: '',
              streetTypeName: ''
            },
            description: '',
            eventType: '',
            from: {
              timestamp: ''
            } as TimestampCustom,
            municipality: '',
            to: {
              timestamp: ''
            } as TimestampCustom
          };
        }
        break;
      case 'PROF':
        this.showRepresent = true;
        this.showCompany = true;
        if (this.newException.type_prof === undefined) {
          this.clearTypes();
          this.newException.type_prof = {
            selfResponsibility: false
          };
        }
        break;
      case 'SALARY':
        this.showRepresent = true;
        this.showCompany = true;
        if (this.newException.type_salary === undefined) {
          this.clearTypes();
          this.newException.type_salary = {
            hasRelation: false,
            civilState: '',
            family: 0
          };
        }
        break;
      case 'TRATMED':
        this.showRepresent = true;
        this.showCompany = true;
        if (this.newException.type_tratmed === undefined) {
          this.clearTypes();
          this.newException.type_tratmed = {
            medicalCenter: '',
            selfResponsibility: false,
            TSI: '',
            vehicleOwner: {
              applicantIdentification: {
                name: '',
                firstSurname: '',
                secondSurname: '',
                documentIdentification: '',
                documentType: '',
                dateOfBirth: {} as RequestDate,
              },
              applicantContact: {} as ApplicantIndividualContact
            },
            from: {
              timestamp: ''
            } as TimestampCustom,
            to: {
              timestamp: ''
            } as TimestampCustom
          };
        }
        break;
      default:
        this.showRepresent = true;
        this.showCompany = true;
        break;
    }
  }

  clearTypes() {
    this.newException.type_municipal = undefined;
    this.newException.type_prof = undefined;
    this.newException.type_singular = undefined;
    this.newException.type_tratmed = undefined;
    this.newException.type_vpmr = undefined;
    this.newException.type_malalt = undefined;
    this.newException.type_salary = undefined;
  }

  changeVehicle() {
    if (this.selectedVehicle == 'new') {
      this.vehiclesToCreate = [];
      this.vehiclesToCreate.push({
        vehicleAlias: '',
        vehiclePlate: '',
        ownerDeclaration: false
      } as VehicleRquest
      );
    } else {
      const vehicle = this.vehicles.find((vehicle) => vehicle.vehiclePlate === this.selectedVehicle);
      if (vehicle) {
        this.createdVehiclePlate = vehicle.vehiclePlate;
        this.createdVehicleAlias = vehicle.vehicleAlias;
        this.ownerDeclaration = vehicle.ownerDeclaration;
      }
    }
  }

  removeVehicle(index: number): void {
    this.vehiclesToCreate.splice(index, 1);
  }

  addVehicle(): void {
    this.vehiclesToCreate.push({
      vehicleAlias: '',
      vehiclePlate: ''
    } as VehicleRquest);
  }

  clearNegative() {
    if (this.newException.type_salary!.family < 0) {
      this.newException.type_salary!.family = 0;
    }
  }

  async loadFile(fileEvent: any, index: number) {
    if (fileEvent && fileEvent.size > 0) {
      const MAX_SIZE = 5 * 1024 * 1024; // 5MB en bytes
      if (fileEvent.size > MAX_SIZE) {
        alert($localize`:@@Exceptions.Create:El archivo supera el tamaño máximo permitido de 5MB`);
        return;
      }
      // check if attachments has a item with the same name
      if (this.filesToAdd.some((attachment) => attachment?.name === fileEvent.name)) {
        alert($localize`:@@Common.FileExist:Ya existe un archivo con el mismo nombre`);
        // reset show of inpit
        this.filesToShow[index] = false;
        setTimeout(() => {
          this.filesToShow[index] = true;
        }, 100);
        return;
      }
      const attachment = {
        name: fileEvent.name,
        description: '',
        mime: fileEvent.type,
        data: await AttachmentUtil.arrayBufferToString(fileEvent.arrayBuffer())
      } as Attachment;
      this.filesToAdd[index] = attachment;
    }
    // if any item is undefined add a new one
    if (index < this.filesToAdd.length - 1) {
      this.addFile(index);
    }
  }

  addFile(index: number) {
    this.filesToShow[index + 1] = true;
  }

  removeFile(index: number) {
    this.filesToAdd[index] = undefined;
    this.filesToShow[index] = false;
  }

  goBack() {
    this.goBackEvent.emit();
  }

  save() {
    if (this.newException.flags?.email && this.newException.flags?.sms) {
      this.alertService.setAlert({
        message: $localize`:@@Profile.SendEmailSms:Solo puede seleccionar un medio de comunicación, SMS o email.`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      return;
    }
    // check if vehicle ownerDelcaration is false check flags.vehicleDocumentation must be true
    debugger;
    if (!this.newException.flags?.vehicleDocumentation && this.ownerDeclaration === false) {
      this.alertService.setAlert({
        message: $localize`:@@Exceptions.Create.VehicleDocumentation:Debe aceptar la posesión de la documentación acreditativa del vehículo.`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 5000
      });
      return;
    }
    if (this.newException.flags!.privacity && this.newException.flags!.veracity) {
      if (!this.newException.municipalities || this.newException.municipalities.length === 0) {
        this.alertService.setAlert({
          message: $localize`:@@Exceptions.Create.Municipalities:Debe seleccionar al menos un municipio`,
          type: AlertType.Error,
          dismissible: true,
          dismissOnTimeout: 5000
        });
        return;
      }
      if (this.newException.flags!.personal && this.filesToAdd.filter((file) => file !== undefined).length === 0) {
        this.alertService.setAlert({
          message: $localize`:@@Exceptions.Create.Attachments:Debe adjuntar documentos si no acepta la consulta de datos`,
          type: AlertType.Error,
          dismissible: true,
          dismissOnTimeout: 5000
        });
        return;
      }
      // parse dates
      if (this.newException.type_tratmed !== undefined) {
        this.newException.type_tratmed.from.timestamp = new Date(this.typeTratmedFrom).toISOString();
        this.newException.type_tratmed.to.timestamp = new Date(this.typeTratmedTo).toISOString();
        // if to is more than 2 years from from
        if (Date.parse(this.newException.type_tratmed.to.timestamp) - Date.parse(this.newException.type_tratmed.from.timestamp) > 63072000000) {
          this.alertService.setAlert({
            message: $localize`:@@Exceptions.Create.DateRange:El rango de fechas no puede ser superior a 2 años`,
            type: AlertType.Error,
            dismissible: true,
            dismissOnTimeout: 5000
          });
          this.loaderService.hide();
          return;
        }
      }
      if (this.newException.type_municipal !== undefined) {
        this.newException.type_municipal.from.timestamp = new Date(this.typeMunicipalFrom).toISOString();
        this.newException.type_municipal.to.timestamp = new Date(this.typeMunicipalTo).toISOString();
        // if to is more than 2 years from from
        if (Date.parse(this.newException.type_municipal.to.timestamp) - Date.parse(this.newException.type_municipal.from.timestamp) > 63072000000) {
          this.alertService.setAlert({
            message: $localize`:@@Exceptions.Create.DateRange:El rango de fechas no puede ser superior a 2 años`,
            type: AlertType.Error,
            dismissible: true,
            dismissOnTimeout: 5000
          });
          this.loaderService.hide();
          return;
        }
      }
      if (this.selectedVehicle == 'new') {
        if (this.vehiclesToCreate.length === 0 || this.vehiclesToCreate.some((vehicle) => !vehicle.vehiclePlate)) {
          this.alertService.setAlert({
            message: $localize`:@@Exceptions.Create.VehicleData:Debe introducir la matrícula del vehículo`,
            type: AlertType.Error,
            dismissible: true,
            dismissOnTimeout: 5000
          });
          return;
        }
        this.createVehicle();
      } else {
        this.loaderService.show();
        this.newException.attachments = this.filesToAdd.filter((file) => file !== undefined) as Attachment[];
        if (this.newException.type.options && this.newException.type.options.length > 0) {
          this.newException.type.options = this.vehiclesTypes.find((type) => type.code === this.newException.type.code)?.options?.find((option) => option.code === this.tipServCode) ? [this.vehiclesTypes.find((type) => type.code === this.newException.type.code)?.options?.find((option) => option.code === this.tipServCode)!] : [];
        }
        if (this.multiple) {
          if (this.vehiclesFromExcel.length === 0) {
            this.alertService.setAlert({
              message: $localize`:@@Exceptions.Create.NoData:No se ha subido ningún archivo`,
              type: AlertType.Error,
              dismissible: true,
              dismissOnTimeout: 5000
            });
            this.loaderService.hide();
            return;
          }
          this.newException.vehicles = this.vehiclesFromExcel;
          // check if all vehicles have errorMessage
          if (this.vehiclesFromExcel.every((vehicle) => vehicle.errorMessage)) {
            this.loaderService.hide();
            // scroll to #table-vehicles + 300px
            document.getElementById('table-vehicles')?.scrollIntoView({ behavior: 'smooth' });
            this.alertService.setAlert({
              message: $localize`:@@Exceptions.Create.ErrorsAnyValid:No hay vehículos disponibles para crear una exención.`,
              type: AlertType.Error,
              dismissible: true,
              dismissOnTimeout: 5000
            });
          } else {
            // only add exceptions of vehicles without errorMessage
            this.newException.vehicles = this.vehiclesFromExcel.filter((vehicle) => !vehicle.errorMessage);
            this.exceptionsService.addMultipleException(this.newException).subscribe({
              next: (vehicles) => {
                // check if any vehicle has an error
                if (vehicles.some((vehicle) => vehicle.errorMessage)) {
                  this.vehiclesFromExcel = vehicles;
                  this.loaderService.hide();
                  // scroll to #table-vehicles + 300px
                  document.getElementById('table-vehicles')?.scrollIntoView({ behavior: 'smooth' });
                  this.alertService.setAlert({
                    message: $localize`:@@Exceptions.Create.Errors:Se han encontrado errores en los vehículos`,
                    type: AlertType.Error,
                    dismissible: true,
                    dismissOnTimeout: 5000
                  });
                } else {
                  this.loaderService.hide();
                  this.goBackEvent.emit();
                }
              }
            });
          }
        } else {
          this.exceptionsService.addExceptionByApplicant(this.createdVehiclePlate!, this.applicantId, this.newException).subscribe({
            next: (id) => {
              this.loaderService.hide();
              this.goBackEvent.emit();
            }
          });
        }
      }
    } else {
      this.alertService.setAlert({
        message: $localize`:@@Exceptions.Create.Conditions:Debes aceptar la politica de privacidad y protección de datos`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 5000
      });
    }
  }

  createVehicle() {
    if (this.vehiclesToCreate.length > 0) {
      this.vehiclesToCreate.forEach((vehicle) => {
        vehicle.vehiclePlate = vehicle.vehiclePlate.toUpperCase().replace(' ', '');
      });
      this.loaderService.show();
      this.vehiclesService.addVehiclesByApplicant(this.vehiclesToCreate, this.applicantId).subscribe({
        next: (newVehicles: Vehicle[]) => {
          this.alertService.setAlert({
            message: $localize`:@@Vehicles.Create.Createds:Vehículos creados correctamente`,
            type: AlertType.Success,
            dismissible: true,
            dismissOnTimeout: 5000
          });
          let requests: Observable<number>[] = [];
          newVehicles.forEach(vehicle => {
            requests.push(this.exceptionsService.addExceptionByApplicant(vehicle.vehiclePlate, this.applicantId, this.newException));
          });
          forkJoin(requests).subscribe({
            next: (ids: number[]) => {
              this.loaderService.hide();
              this.alertService.setAlert({
                message: $localize`:@@Exceptions.Create.Created:Excepciones creadas correctamente`,
                type: AlertType.Success,
                dismissible: true,
                dismissOnTimeout: 5000
              });
              this.goBackEvent.emit();
            }
          });
        }
      });
    }
  }

  downloadExcel() {
    this.loaderService.show();
    this.exceptionsService.downloadMultipleExcel().subscribe({
      next: (data) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'Plantilla flota.xlsx';
        link.click();
        this.loaderService.hide();
      }
    });
  }

  async loadFileMultiple(filesEvent: any) {
    // create attachment from file
    const input = filesEvent.target as HTMLInputElement;
    var fileEvent = undefined;
    if (input && input.files && input.files.length > 0) {
      fileEvent = input.files[0];
    }
    if (fileEvent && fileEvent.size > 0) {
      const MAX_SIZE = 5 * 1024 * 1024; // 5MB en bytes
      if (fileEvent.size > MAX_SIZE) {
        alert($localize`:@@Exceptions.Create:El archivo supera el tamaño máximo permitido de 5MB`);
        return;
      }
      const attachment = {
        name: fileEvent.name,
        description: '',
        mime: fileEvent.type,
        data: await AttachmentUtil.arrayBufferToString(fileEvent.arrayBuffer())
      } as Attachment;
      this.multipleFile = attachment;
      this.uploadExcel();
    }
  }

  triggerFileInput() {
    const fileInput = document.getElementById('upload-excel') as HTMLInputElement;
    // clear input value
    fileInput.value = '';
    if (fileInput) {
      fileInput.click();
    }
  }

  uploadExcel() {
    if (!this.multipleFile) {
      this.alertService.setAlert({
        message: $localize`:@@Exceptions.Create.NoFile:No se ha seleccionado ningún archivo`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 5000
      });
      return;
    }
    this.loaderService.show();
    this.exceptionsService.uploadMultipleExcel(this.multipleFile).subscribe({
      next: (data) => {
        if (data.length === 0) {
          this.loaderService.hide();
          this.alertService.setAlert({
            message: $localize`:@@Exceptions.Create.NoVehicles:No hay vehículos disponibles para crear una exención.`,
            type: AlertType.Error,
            dismissible: true,
            dismissOnTimeout: 5000
          });
        } else {
          this.vehiclesFromExcel = data;
          this.alertService.setAlert({
            message: $localize`:@@Exceptions.Create.Uploaded:Vehículos cargados, revise los posibles problemas en la tabla de vehículos`,
            type: AlertType.Success,
            dismissible: true,
            dismissOnTimeout: 5000
          });
        }
        this.loaderService.hide();
      }
    });
  }
}
